export function getLoginBacklink() {
    let backlink = localStorage.getItem('__datixo__loginBacklink');

    if (backlink === 'null') {
        backlink = null;
    }

    return backlink;
}

export function setLoginBacklink(loginBacklink = null) {
    localStorage.setItem('__datixo__loginBacklink', loginBacklink);
}
